module.exports = __webpack_public_path__ + "static/media/columnImageLeft.29ffbf1c.png";